import {hasPermission, useUser} from "../../../../misc/Permission";
import {
    StringCol,
    Table, ViewOnly,
} from "../../../../misc/scroller/Table";
import {priceTableName} from "./Pricing";
import {useProjectId} from "../ProjectName";
import React, {useContext} from "react";
import {ManagerLockContext} from "../ProjectActions";
import {
    PriceLine2,
} from "./Frames";
import {commonPricingColumns3, sovCellCustomize, sovColumns, usePricingKit2} from "./usePricingKit2";
import {getAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {onPricingChangeWrap} from "./PricingTabs";
import {useCheckboxExtSetupData} from "../../manage/sov/CheckboxExtProvider";

export function Div10(props: {
    filterByChangeset?: boolean;
    sov?: number;
}) {
    const project = useProjectId();
    const {locked} = useContext(ManagerLockContext)
    const u = useUser();

    const kit = usePricingKit2(project);
    const checkboxAllData = useCheckboxExtSetupData();

    if(!u) return null;
    if(kit.Loading) return <>{kit.Loading}</>

    return (
        <>
            <Table<PriceLine2>
                name={priceTableName(project, "div10")}
                globalPrefsName={priceTableName(0, "div10")}
                cellCustomize=
                    {props.sov ? sovCellCustomize(props.sov) :
                    kit.cellCustomize
                }
                locked={locked && !hasPermission(u, "EditShopDrawingWhenLockedToManager")}
                fetch={async (ctx) => checkboxAllData(getAll(ctx, offset =>
                    api.pricing.list({
                        project: project, offset,
                        previewChangeset: kit.sessionId,
                        category: "div10",
                        refunded: props.filterByChangeset ? false : undefined,
                        filterByChangeset: props.filterByChangeset,
                        forSovLink: !!props.sov,
                    })
                ))}
                columns={[
                    ...sovColumns(props.sov),
                    ViewOnly(StringCol("Room", "room")),
                    ViewOnly(StringCol("Type", "category")),
                    ViewOnly(StringCol("Product", "name")),
                    ViewOnly(StringCol("Code", "productCode")),
                    ...commonPricingColumns3(u, kit.markup?.frame + "%", props.sov),
                ]}
                columnDeps={[u, kit.markup, props.sov]}
                fetchDeps={[project, kit.sessionId, props.sov]}
                onChange={(input) => onPricingChangeWrap(api.pricing.upsert(input))}
            />
        </>
    )
}
